<button
  class="button button-border button-border--medium"
  translate="account.link.trade"
  (click)="controlTradeButton(account)"
></button>
